import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery, useReactiveVar } from '@apollo/client';
import { DialogTypes } from 'common/enums/components/dialog-types.enum';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { SPORT_EVENT } from 'common/graphql/queries/sportEvent/sportEvent';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openDialog, openSnackbar } from 'store/actions';
import { userProfileDataVar } from 'utils/apollo/reactivities/userProfileDataVar';
var JoinSportEventsTeamsDialog = function (_a) {
    var sportEventId = _a.sportEventId, handleClose = _a.handleClose;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var userProfile = useReactiveVar(userProfileDataVar).userProfile;
    var currentUserId = userProfile === null || userProfile === void 0 ? void 0 : userProfile.id;
    var _b = useQuery(SPORT_EVENT, {
        variables: {
            id: sportEventId,
            showTournaments: true
        }
    }), data = _b.data, loading = _b.loading, error = _b.error;
    useEffect(function () {
        var _a, _b, _c;
        if (error) {
            dispatch(openSnackbar({
                message: error.message || ((_c = (_b = (_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.extensions) === null || _c === void 0 ? void 0 : _c.code) || t('Ошибка при загрузке данных'),
                severity: SnackbarSeverity.ERROR
            }));
            handleClose();
        }
    }, [error]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (data && ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.sportEvent) === null || _a === void 0 ? void 0 : _a.tournaments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id)) {
            dispatch(openDialog({
                dialogType: DialogTypes.TournamentTeamsDialog,
                dialogProps: {
                    tournamentId: (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.sportEvent) === null || _d === void 0 ? void 0 : _d.tournaments) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.id,
                    currentUserId: currentUserId,
                    isUserTeamParticipant: false
                }
            }));
        }
    }, [data]);
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return null;
};
export default JoinSportEventsTeamsDialog;
